export var _rating_data = {
    collage_title: 'все участники',
    collages: {
        1275: { name: 'Кирилл александров', scores: 10 },
        1276: { name: 'Саша Васильев', scores: 10 },
        1277: { name: 'Саша Васильев', scores: 10 },
    },
    intro: {
        items: [
            'Поделитесь своей работой в социальных сетях',
            'Приглашайте друзей переходить по ссылке с вашей работы',
            'Чем больше переходов — тем больше у вас баллов',
        ],
        rules: { text: 'Полные правила', link: '/files/rules.pdf', newWin: true }
    }
};
